<template>
  <div class="GeneralSales">
    <div class="headerGeneralSales">
      <b-button class="BtnRegister" @click="handleModals('frenteDeCaixa')">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 3px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Novo PDV</span>
      </b-button>
      <div class="searchContainer">
        <div class="searchInput">
          <b-form-select
            class="searchFilter"
            size="sm"
            value-field="value"
            text-field="text"
            v-model="type"
            :options="filterCombobox"
          ></b-form-select>
          <div v-if="type === 'status'">
            <b-form-select
              class="searchFilterSituation custom-select2"
              value-field="value"
              text-field="text"
              v-model="textPesquisa"
              :options="filterSituationCombobox"
            ></b-form-select>
            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>
          <div v-else-if="type === 'nomeFuncionario'" class="selectPlus">
            <b-form-select
              class="borderInput shadow-none"
              size="sm"
              value-field="nomeFuncionario"
              text-field="nomeFuncionario"
              :options="dataEmployee"
              v-model="textPesquisa"
            >
            </b-form-select>
            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>
          <div v-else>
            <b-input
              class="inputSearch"
              placeholder="Pesquisar por..."
              v-model="textPesquisa"
              @keyup.enter="filterSale(page)"
            ></b-input>
          </div>
        </div>
        <div class="lineSearch">
          <div class="summaryMonth">
            Resumo: &nbsp;
            <strong>{{
              selectTextDate === "Personalizado" ? "" : `(${selectTextDate})`
            }}</strong>
          </div>
          <div class="pagMonth"></div>
          <div
            class="searchInput"
            style="
              padding: 0px !important;
              display: flex;
              justify-content: space-between;
            "
            v-if="selectTextDate === 'Personalizado'"
          >
            <button class="btnPeriod" size="sm">Período</button>
            <div class="dateInput">
              <input
                type="date"
                id="date"
                v-model="startDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                  cursor: pointer;
                  border-left: none;
                  width: 120px;
                  border-radius: 0px 5px 5px 0px;
                "
              />
              <input
                type="date"
                id="date"
                v-model="endDate"
                style="
                  padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                  cursor: pointer;
                  width: 120px;
                  border-right: none;
                  border-radius: 5px 0 0 5px;
                "
              />
            </div>
            <b-button size="sm" @click="filterSale(page)" class="searchBtn">
              <b-icon-search></b-icon-search>
            </b-button>
          </div>

          <div style="width: 25px">
            <DropdownFilters @handleFilterDays="handleFilterDays" />
          </div>
        </div>
      </div>
    </div>
    <div class="headerCounter">
      <b-button class="BtnCounter" @click="handleTypeSale('faturado')">
        <span
          style="
            width: 10px;
            height: 10px;
            background: green;
            border-radius: 50%;
          "
        ></span>
        <span> Faturadas -</span>
        <span> {{ this.countFaturado }} </span>
        <span>
          (
          {{
            canViewSummaryValues
              ? this.totalFaturado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button class="BtnCounter" @click="handleTypeSale('finalizado')">
        <span
          style="
            width: 10px;
            height: 10px;
            background: #006256;
            border-radius: 50%;
          "
        ></span>
        <span>Finalizadas -</span>
        <span> {{ this.countFinalizado }} </span>
        <span>
          (
          {{
            canViewSummaryValues
              ? this.totalfinalizado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )</span
        >
      </b-button>
      <b-button class="BtnCounter" @click="handleTypeSale('cancelado')">
        <span
          style="
            width: 10px;
            height: 10px;
            background: #4f0000;
            border-radius: 50%;
          "
        ></span>
        <span>Canceladas -</span>
        <span> {{ this.countCancelado }} </span>
        <span
          >(
          {{
            canViewSummaryValues
              ? this.totalcancelado.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              : "R$ ****"
          }}
          )
        </span>
      </b-button>
    </div>
    <div class="generalContainer">
      <div class="rowProvisionService" v-if="spinGeneral">
        <div class="loadingLazy">
          <div class="loader">
            <span>WINFIT</span>
            <span>WINFIT</span>
          </div>
          <span style="">Buscando Informações...</span>
        </div>
      </div>
      <div class="rowProvisionService" v-else>
        <div class="ContentTable" v-if="this.dataLength > 0">
          <div class="headerTable">
            <div class="celTable" style="width: 5%; text-align: center">Nº</div>
            <div class="celTable" style="width: 10%">Data</div>
            <div class="celTable" style="width: 40%">Cliente</div>
            <div class="celTable" style="width: 20%">Funcionário</div>
            <div class="celTable" style="width: 15%">Valor</div>
            <div class="celTable" style="width: 9%">Status</div>
            <div class="celTableActions" style="width: 7%">Ações</div>
          </div>
          
          <div
            v-for="dataSearchSale in dataSale"
            :key="dataSearchSale.id"
            :class="`rowSupplier`"
            @click.stop="editSales(dataSearchSale.id)"
          >
            <div
              class="celTable"
              style="
                width: 4%;
                justify-content: center;
                align-items: center;
                text-align: center;
              "
            >
              <span
                style="
                  width: 100%;
                  font-weight: bold;
                  color: #006256;
                  font-size: 13px;
                "
              >
                {{ dataSearchSale.numero || 0 }}
              </span>
            </div>
            <div class="celTable" style="width: 10%">
              {{ dataSearchSale.data.split("-").reverse().join("/") }}
            </div>
            <div
              class="celTable"
              style="
                width: 40%;
                font-weight: bold;
                text-transform: uppercase;
                padding-left: 3px;
              "
            >
              {{ dataSearchSale.nomeCliente || "CONSUMIDOR FINAL" }}
            </div>
            <div class="celTable" style="width: 20%">
              {{ dataSearchSale.nomeFuncionario || "Não informado" }}
            </div>
            <div class="celTable" style="width: 15%">
              {{
                dataSearchSale.valorTotal.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </div>
            <div
              class="celTable"
              v-if="
                dataSearchSale.idNota !== null &&
                dataSearchSale.statusNota === 'Emitida'
              "
              style="
                color: #006256;
                width: 9%;
                background-color: #d4edbc;
                border-radius: 8px;
              "
            >
              Faturado
            </div>
            <div
              class="celTable"
              style="
                color: red;
                width: 9%;
                background-color: #ffcfc9;
                border-radius: 8px;
              "
              v-else-if="
                dataSearchSale.idNota === null &&
                dataSearchSale.status === 'Cancelado'
              "
            >
              {{ dataSearchSale.status }}
            </div>
            <div
              class="celTable"
              style="
                color: #3e66ae;
                width: 9%;
                background-color: #ddebff;
                border-radius: 8px;
              "
              v-else
            >
              {{ dataSearchSale.status }}
            </div>
            <div class="celTableActions">
              <div class="btnActions" v-if="dataSearchSale.idNota !== null">
                <b-dropdown
                  id="dropdown-1"
                  class="btnActions1"
                  variant="none"
                  size="sm"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                  </template>
                  <b-dropdown-item
                    @click.stop="printReportCoupon(dataSearchSale.id)"
                  >
                    Imprimir Recibo
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataSearchSale.idNota !== null &&
                      dataSearchSale.statusNota !== 'Não Enviada'
                    "
                    @click.stop="findAndViewNote(dataSearchSale.idNota)"
                    >Visualizar DANFE</b-dropdown-item
                  >
                  <b-dropdown-item
                    @click.stop="
                      handleOpenModalAndFindFiscalDocument(
                        'modal-cancel',
                        dataSearchSale
                      )
                    "
                    v-if="
                      dataSearchSale.idNota !== null &&
                      dataSearchSale.statusNota === 'Emitida'
                    "
                  >
                    Cancelar NFC-e
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="btnActions" v-else>
                <b-dropdown
                  id="dropdown-1"
                  class="btnActions1"
                  variant="none"
                  size="sm"
                >
                  <template #button-content>
                    <b-icon-gear-fill class="contentActions"></b-icon-gear-fill>
                  </template>

                  <b-dropdown-item
                    @click.stop="printReportCoupon(dataSearchSale.id)"
                  >
                    Imprimir Recibo
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataSearchSale.status !== 'Cancelado'"
                    @click.stop="cancelPdv(dataSearchSale)"
                  >
                    Cancelar PDV
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataSearchSale.status === 'Cancelado'"
                    @click.stop="openPdv(dataSearchSale)"
                  >
                    Reabrir PDV
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="dataSearchSale.idNota === null"
                    @click.stop="sendCoupon(dataSearchSale.id)"
                    >Emitir NFC-e</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40vh;
            max-height: 100vh;
            overflow: auto;
            padding: 10px 20px;
            width: 100%;
            max-width: 100%;
          "
        >
          <span style="font-size: 1rem; font-weight: bold; color: gray"
            >Não há dados para exibir ...</span
          >
        </div>
      </div>
    </div>
    <b-modal
      id="modal-center3"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div>
        <h6 class="titleModal">Deseja excluir essa movimentação ?</h6>
        <div
          v-if="spinGeneral"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 30px;
          "
        >
          <div class="loader">
            <span>WINFIT</span>
            <span>WINFIT</span>
          </div>
        </div>
        <div class="btnModal">
          <button class="btnContent" @click="deleteSale">Deletar</button>
          <button
            class="btnContentReceive"
            @click="$bvModal.hide('modal-center3')"
          >
            Não, Obrigado!
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal id="modal-cancel" hide-footer hide-header centered title="Excluir">
      <div>
        <h4 class="titleModal" style="text-align: center">
          Deseja cancelar essa {{ nameFiscalDocument }} ?
        </h4>
        <div class="btnModalCancel">
          <div class="contentMotivo">
            <label>Descreva o motivo do cancelamento:</label> <span>*</span>
            <b-form-textarea
              placeholder="Min: 15 caracteres"
              style="color: black; width: 100% !important"
              v-model="motivo"
            ></b-form-textarea>
          </div>
          <div class="contentBtns">
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modal-cancel')"
            >
              Não, Obrigado!
            </button>
            <button class="btnContent" @click="cancelNota">Cancelar</button>
          </div>
        </div>
        <span class="alertCancel">
          O prazo máximo para cancelamento de uma {{ nameFiscalDocument }} é de
          até {{ textTimeToCancel }} após a concessão da autorização de uso.
        </span>
      </div>
    </b-modal>
    <b-modal
      id="modal-cancel-sale"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <h4
          v-if="this.itemSelectedInTableSearch"
          class="titleModal"
          style="text-align: center"
        >
          Deseja cancelar a venda N°
          {{ this.itemSelectedInTableSearch.numero || 0 }} ?
        </h4>
        <p style="margin: 0 !important; font-size: 14px; color: #00285a">
          Código de confirmação
        </p>
        <div class="pin-container">
          <input
            v-for="(n, index) in 4"
            :key="index"
            :ref="'pin' + index"
            v-model="digits[index]"
            type="text"
            maxlength="1"
            pattern="\d*"
            inputmode="numeric"
            @input="handleInput(index)"
            @keydown.delete="handleDelete(index)"
            class="pin-input"
          />
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            gap: 20px;
            padding: 20px;
            width: 100%;
          "
        >
          <button class="btnContent" @click="cancelSale()">Cancelar</button>
          <button class="btnContentReceive" @click="clearPin()">
            Não, Obrigado!
          </button>
        </div>
        <span
          style="
            font-size: 12px;
            color: #00285a;
            text-align: justify;
            display: flex;
            cursor: context-menu;
          "
        >
          Ao realizar o cancelamento da venda, todas as parcelas vinculadas ao
          pedido serão excluídas e será realizado o estorno do estoque dos
          produtos.
        </span>
      </div>
    </b-modal>
    <b-modal
      id="modal-open-sale"
      hide-footer
      hide-header
      centered
      title="Excluir"
    >
      <div style="display: flex; flex-direction: column; align-items: center">
        <h4
          v-if="this.itemSelectedInTableSearch"
          class="titleModal"
          style="text-align: center"
        >
          Deseja reabrir a venda N°
          {{ this.itemSelectedInTableSearch.numero || 0 }} ?
        </h4>
        <p style="margin: 0 !important; font-size: 14px; color: #00285a">
          Código de confirmação
        </p>
        <div class="pin-container">
          <input
            v-for="(n, index) in 4"
            :key="index"
            :ref="'pin' + index"
            v-model="digits[index]"
            type="text"
            maxlength="1"
            pattern="\d*"
            inputmode="numeric"
            @input="handleInput(index)"
            @keydown.delete="handleDelete(index)"
            class="pin-input"
          />
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            gap: 20px;
            padding: 20px;
            width: 100%;
          "
        >
          <button class="btnContent" @click="reOpenSale()">Reabrir PDV</button>
          <button class="btnContentReceive" @click="clearPin()">
            Não, Obrigado!
          </button>
        </div>
        <span
          style="
            font-size: 12px;
            color: #00285a;
            text-align: justify;
            display: flex;
            cursor: context-menu;
          "
        >
          Ao realizar a reabertura da venda, será realizado a baixa do estoque
          dos produtos adicionados.Porém as parcelas não serão reativadas.
        </span>
      </div>
    </b-modal>

    <!-- <b-modal
      id="modal-center4"
      hide-footer
      hide-header
      centered
      size="xl"
      title="Detalhes"
    >
      <div class="closeModalDetails" @click="$bvModal.hide('modal-center4')">
        X
      </div>
      <div class="contentModal">
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            text-transform: uppercase;
            color: #006256;
            border-bottom: 1px dashed #006256;
            margin-bottom: 10px;
          "
        >
          <span>Venda Nº: {{ detailsSales.numero || 0 }}</span>
          <span>{{ this.detailsSales.status }}</span>
        </div>

        <div class="rowModalDetails">
          <div class="headerDetails">
            <span style="width: 20%">Data </span>
            <span style="width: 40%">Cliente </span>
            <span style="width: 20%">CPF/CNPJ </span>
            <span style="width: 20%">Funcionario </span>
          </div>
          <div class="contentDetails">
            <span class="celDetails" style="width: 20%">{{
              this.detailsSales.data
            }}</span>
            <span class="celDetails" style="width: 40%">{{
              this.detailsSales.nomeCliente
            }}</span>
            <span class="celDetails" style="width: 20%">{{
              this.detailsSales.cpfCnpj
            }}</span>
            <span class="celDetails" style="width: 20%">{{
              this.detailsSales.nomeFuncionario
            }}</span>
          </div>
        </div>
      </div>
      <div class="contentModal">
        <span class="titleSectionDetails">Produtos</span>
        <div class="headerDetails">
          <span style="width: 40%">Nome </span>
          <span style="width: 20%">Qtd </span>
          <span style="width: 20%">Vl. Unit.</span>
          <span style="width: 20%">Desconto </span>
          <span style="width: 20%">Vl. Total </span>
        </div>
        <div
          class="contentDetails"
          v-for="detailsSale in this.detailsSales.products"
          :key="detailsSale.id"
        >
          <span class="celDetails" style="width: 40%">
            {{ detailsSale.nome }}</span
          >
          <span class="celDetails" style="width: 20%">{{
            detailsSale.quantidade
          }}</span>
          <span class="celDetails" style="width: 20%">{{
            detailsSale.valorUnitario.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span>
          <span class="celDetails" style="width: 20%">{{
            detailsSale.desconto.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span>
          <span class="celDetails" style="width: 20%">{{
            detailsSale.valorTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</span>
        </div>
      </div>
      <div class="contentModal">
        <span class="titleSectionDetails"> Duplicatas</span>
        <div class="ContentTableBill">
          <div class="noContentTable" v-if="this.detailsSales.bills == ''">
            Não há duplicatas pagas registradas!
          </div>
          <div class="rowModalDetails" v-else>
            <div class="headerDetails">
              <span style="width: 15%">Data </span>
              <span style="width: 15%">Dt. Pagamento </span>
              <span style="width: 10%">Status </span>
              <span style="width: 20%">Forma Pagamento</span>
              <span style="width: 20%">Vl Total </span>
              <span style="width: 20%">Vl Pago </span>
              <span style="width: 5%">Excluir </span>
            </div>
            <div
              class="contentDetails"
              v-for="dataBill in this.detailsSales.bills"
              :key="dataBill.id"
            >
              <span class="celDetails" style="width: 15%">{{
                dataBill.data.split(" ")[0].split("-").reverse().join("/")
              }}</span>
              <span class="celDetails" style="width: 15%">{{
                dataBill.dataPagamento
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
              <span
                class="contentStatus"
                style="width: 10%"
                v-if="!dataBill.dataPagamento"
              >
                <b-icon-x-circle-fill
                  class="statusPaymentOpen"
                ></b-icon-x-circle-fill>
                <span style="width: 50%">Em aberto</span>
              </span>
              <span class="contentStatus" style="width: 10%" v-else>
                <b-icon-check-circle-fill
                  class="statusPayment"
                ></b-icon-check-circle-fill>
                <span style="width: 50%">Pago</span>
              </span>
              <span class="celDetails" style="width: 20%">{{
                dataBill.tipoFormaPagamento
              }}</span>
              <span class="celDetails" style="width: 20%">{{
                dataBill.valorTotal.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <span class="celDetails" style="width: 20%">{{
                dataBill.valorPago.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}</span>
              <span class="celDetails" style="width: 5%; align-items: center">
                <b-icon-x-circle
                  scale="1.5"
                  class="delBill"
                  @click="deleteBill(dataBill.id)"
              /></span>
            </div>
          </div>
        </div>
      </div>
    </b-modal> -->

    <ModalDetailsSales
      modalName="modalDetailsPDV"
      headerIcon="b-icon-exclamation-triangle-fill"
      :sale="detailsSales"
    />

    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="this.dataLength < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>
    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalSales" @click="modalHeight"> X </b-button>
        <BoxFront v-if="this.typeDocument.frenteDeCaixa" />
      </div>
    </div>
    <Loading v-if="spinLoading" :text="textToModalLoading" />
  </div>
</template>
<script>
import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";

import BoxFront from "../BoxFront/Index-BoxFront.vue";
import Loading from "../Loading/Loading.vue";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";
import ModalDetailsSales from "../GeneralSalesScreen/ModalDetailsSales.vue";

import ServiceSale from "../../services/serviceSale";
import ServiceBill from "../../services/serviceBill";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";
import ServiceSettings from "../../services/serviceSettings";

import { TypeSale } from "../../utils/enums/SalesType";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { TypesOfSales } from "../../utils/enums/TypesOfSales";
import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import printReport from "../../reports/sale";
import { formatValuesFromSales } from "../../helpers/generalSales";
import { hasSummaryValuesPermission } from "../../utils/summaryValuesPermission";

export default {
  components: {
    BoxFront,
    Loading,
    DropdownFilters,
    ModalDetailsSales,
  },
  props: {
    initialMonth: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      digits: ["", "", "", ""],
      selectTextDate: "Este mês",
      year: DateTime.local().year,
      month: DateTime.local(),
      typeSale: TypeSale,
      spinLoading: false,
      spinGeneral: false,
      textPesquisa: "",
      type: "",
      typeOfSales: TypesOfSales.normal,
      typeSituation: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      modalContainer: "contentModalDisable",
      dataSale: [],
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      totalFaturado: 0,
      countFaturado: 0,
      dataBills: "",
      page: 1,
      dataLength: 0,
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "numero", text: "Nº Operação" },
        { value: "status", text: "Status" },
        { value: "", text: "Selecione..." },
      ],
      filterSituationCombobox: [
        { value: "Cancelado", text: "Cancelado" },
        { value: "Finalizado(a)", text: "Finalizado" },
        { value: "Faturado(a)", text: "Faturado" },
        { value: "", text: " Clique para selecionar a situação " },
      ],
      dataSaleUnique: "",
      detailsSales: "",
      returnDataNote: null,
      motivo: "",
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      itemSelectedInTableSearch: null,
      textToModalLoading: "",
      dataEmployee: [],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "ALTER_TYPE_DOCUMENT",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_DATA_NFE",
    ]),
    getIdSale(idSale) {
      this.dataSaleUnique = idSale;

      this.findBill();
    },

    async getIdSaleDetails(idSale) {
      this.detailsSales = await this.findCompletedSale(idSale);
      this.dataSaleUnique = idSale;

      const dataSalesFormated = this.detailsSales.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      this.detailsSales.data = dataSalesFormated;
    },

    async findBill() {
      this.detailsSales.bills = await ServiceBill.getAllBillsByParamsId(
        this.dataSaleUnique,
        BillColumnsToSearchById.idVenda
      );
    },

    async findBillReportTicket(idSale) {
      const token = localStorage.getItem("token");
      const result = await ServiceSettings.findSettingsAtm();
      if (result.juros) {
        this.dataSaleUnique = idSale;
        window.open(
          `${process.env.VUE_APP_URL_BACKEND}/bills/print/report/ticket/all/bills/and/format/carne/completed/with/pix/one/${this.dataSaleUnique}?auth=${token}`
        );
      }
    },
    async listEmployeesSelectBox() {
      try {
        const { data } = await api.get("/employees/combobox/fill");
        this.dataEmployee = data.data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async deleteBill(id) {
      await ServiceBill.deleteAllRelationshipsFromDuplicate(id);

      this.findBill();
    },
    openDelete(idSale) {
      this.$bvModal.show("modal-center3");
      this.getIdSale(idSale);
    },
    async deleteSale() {
      try {
        this.spinGeneral = true;
        await ServiceSale.deleteAll(this.dataSaleUnique);
        this.clearSearch();
        await this.filterSale(1);
        this.$bvModal.hide("modal-center3");
        return this.$toast.open({
          message: "Venda removida com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterSale(page) {
      if (this.selectTextDate === "Personalizado") {
        if (this.startDate && this.endDate) {
          const start = DateTime.fromISO(this.startDate);
          const end = DateTime.fromISO(this.endDate);
          const diffInMonths = end.diff(start, "months").months;

          if (diffInMonths > 6) {
            this.$toast.open({
              message:
                "Atenção! Período superior a 6 meses.Para esse intervalo, utilize o módulo Relatórios.",
              type: "info",
            });
            return;
          }

          if (end < start) {
            this.$toast.open({
              message: "A data final não pode ser anterior à data inicial",
              type: "warning",
            });
            return;
          }
        }
      }
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/sales/pdv/search?q=${this.textPesquisa}&type=${this.type}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data;
        if (data.totals && Object.keys(data.totals).length) {
          this.countCancelado = data.totals.countCancelado;
          this.countFinalizado = data.totals.countFinalizado;
          this.countRascunho = data.totals.countRascunho;
          this.countFaturado = data.totals.countFaturado;

          this.totalcancelado = data.totals.cancelado;
          this.totalfinalizado = data.totals.finalizado;
          this.totalrascunho = data.totals.rascunho;
          this.totalFaturado = data.totals.faturado;
        }
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }

      await this.filterSale(1);
    },
    handleTypeSale(name) {
      this.type = "status";
      this.textPesquisa = name;

      this.filterSale(1);
    },

    nextPage() {
      this.filterSale((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1));
      }
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
        this.SET_DATA_SEARCH_FROM_SALE({});
      }
      this.filterSale(1);
    },

    async editSales(idSale) {
      this.detailsSales = await this.findCompletedSale(idSale);
      this.dataSaleUnique = idSale;

      const dataSalesFormated = this.detailsSales.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      this.detailsSales.data = dataSalesFormated;
      this.$bvModal.show("modalDetailsPDV");
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    async findCompletedSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/details/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_DOCUMENT(name);

      this.modalHeight();
    },

    handleEditBoxFront(typeDocument, data) {
      const formatedBoxFront = formatValuesFromSales(typeDocument, data);
      this.SET_DATA_SEARCH_FROM_BOX_FRONT(formatedBoxFront);

      const nameDocument = "frenteDeCaixa";
      this.ALTER_TYPE_DOCUMENT(nameDocument);
      this.modalHeight();
    },

    handleEditSale(typeDocument, data) {
      const formatedSale = formatValuesFromSales(typeDocument, data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      const nameDocument = "venda";
      this.ALTER_TYPE_DOCUMENT(nameDocument);
      this.modalHeight();
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
      this.page = 1;
    },

    async transformToNfe(idSale, typeSale) {
      try {
        let dataNFe;
        if (typeSale === this.typeSale.venda) {
          dataNFe = await ServiceSale.transformInNotaToSend(idSale);

          this.SET_DATA_NFE(dataNFe);

          this.$toast.open({
            message: "Venda transformada em nota fiscal!",
            type: "success",
          });

          this.$router.push({
            path: `/fiscal`,
          });
        }
      } catch (error) {
        if (
          error?.response?.data?.message &&
          error?.response?.data?.message?.includes("Validation failed")
        ) {
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        }

        return toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async handleDuplicateSale(dataSearchSale) {
      const data = await this.formatValuesToDuplicate(dataSearchSale.id);

      if (Object.keys(data).length) {
        data.numero = "";

        if (dataSearchSale.tipo === this.typeSale.venda) {
          this.handleEditSale(dataSearchSale.tipo, data);
        }
      }

      return;
    },

    async formatValuesToDuplicate(idSale) {
      const data = await this.searchTableDataForSale(idSale);

      const newProductsSale = data.products.map((prod) => {
        prod.id = "";
        prod.idVenda = "";

        return prod;
      });

      data.id = "";
      data.products = newProductsSale;
      data.bills = [];

      return data;
    },

    async sendCoupon(idSale) {
      try {
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! O Seu cupom está sendo emitido !";

        const data = await ServiceNotaFiscal.sendCoupon(idSale);
        this.responseNfeWebMania.danfe = await data.dataWebMania.danfe;
        this.visualizarNfe(this.responseNfeWebMania.danfe);

        await this.filterSale(1);
        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
      }
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    async findNotaById(idNota) {
      this.returnDataNote = await ServiceNotaFiscal.findNotaById(idNota);
    },

    async findAndViewNote(idNota) {
      const notaReturn = await ServiceNotaFiscal.findNotaById(idNota);
      if (notaReturn.status === "Não Enviada") {
        this.$toast.open({
          message:
            "Houve um erro! Verifique se o documento foi emitido e tente novamente",
          type: "info",
        });
      } else {
        this.visualizarNfe(notaReturn.response.danfe);
      }
    },

    async cancelNota() {
      try {
        await this.findNotaById(this.itemSelectedInTableSearch.idNota);

        const dataCancelamento = {
          uuid: this.returnDataNote.response.uuid,
          motivo: this.motivo,
        };
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! O Seu cupom está sendo cancelado !";

        await ServiceNotaFiscal.cancelNota(
          dataCancelamento,
          this.returnDataNote.id
        );

        this.$toast.open({
          message: "Nota Cancelada!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Houve um erro! Verifique e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
        this.motivo = "";
      }
    },

    printCouponOrA4(type, idSale) {
      if (type === this.typeSale.frenteDeCaixa) {
        this.printReportCoupon(idSale);
      } else {
        this.printReportVendaOrcamento(idSale);
      }
    },
    cancelPdv(dataSearchSale) {
      this.handleOpenModalAndFindFiscalDocument(
        "modal-cancel-sale",
        dataSearchSale
      );
    },
    openPdv(dataSearchSale) {
      this.handleOpenModalAndFindFiscalDocument(
        "modal-open-sale",
        dataSearchSale
      );
    },
    printReportCoupon(idSale) {
      printReport("reportCoupon", idSale);
    },

    printReportVendaOrcamento(idSale) {
      printReport("reportVendaOrcamento", idSale);
    },

    async handleOpenModalAndFindFiscalDocument(nameModal, dataSearchSale) {
      this.itemSelectedInTableSearch = dataSearchSale;
      this.openModal(nameModal);
    },
    clearPin() {
      this.digits = ["", "", "", ""];

      this.$nextTick(() => {
        this.$refs["pin0"][0].focus();
      });
      this.$bvModal.hide("modal-cancel-sale");
      this.$bvModal.hide("modal-open-sale");
    },
    async cancelSale() {
      try {
        await ServiceSale.cancel(
          this.itemSelectedInTableSearch.id,
          this.itemSelectedInTableSearch.status
        );
        this.filterSale(1);
        this.clearPin();
        this.$bvModal.hide("modal-cancel-sale");
        return this.$toast.open({
          message: "Venda cancelada!",
          type: "success",
        });
      } catch (error) {
        toastAlertErros.validateMessage(error, this.$toast);
      }
    },
    async reOpenSale() {
      try {
        await ServiceSale.reOpen(this.itemSelectedInTableSearch.id);
        this.filterSale(1);
        this.clearPin();
        this.$bvModal.hide("modal-open-sale");
        return this.$toast.open({
          message: "Venda reaberta!",
          type: "success",
        });
      } catch (error) {
        toastAlertErros.validateMessage(error, this.$toast);
      }
    },
    openModal(nameModal) {
      this.$bvModal.show(nameModal);
    },
    handleInput(index) {
      if (this.digits[index] && index < 3) {
        this.$refs["pin" + (index + 1)][0].focus();
      }
    },
    handleDelete(index) {
      if (!this.digits[index] && index > 0) {
        this.$refs["pin" + (index - 1)][0].focus();
      }
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      typeDocument: (state) => state.typeDocument,
    }),
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    canViewSummaryValues() {
      return hasSummaryValuesPermission("novoPDV");
    },
    fullCode() {
      return this.digits.join("");
    },
    nameFiscalDocument() {
      if (
        this.itemSelectedInTableSearch &&
        String(this.itemSelectedInTableSearch?.modeloNota) === "2"
      ) {
        return "NFC-e";
      } else {
        return "NF-e";
      }
    },
    textTimeToCancel() {
      if (
        this.itemSelectedInTableSearch &&
        String(this.itemSelectedInTableSearch?.modeloNota) === "2"
      ) {
        return "30 MINUTOS";
      } else {
        return "24 HORAS";
      }
    },
    isStoneIntegration() {
      if (
        this.dataCompany?.liberars[0]?.integracoes &&
        Object.keys(this.dataCompany?.liberars[0]?.integracoes).length
      ) {
        const stone =
          this.dataCompany?.liberars[0]?.integracoes.cardMachines.find(
            (machine) => machine.text === "STONE"
          );

        return stone.value;
      }

      return false;
    },
  },
  async created() {
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    this.filterSale(1);
    this.listEmployeesSelectBox();
    this.ALTER_SIZE_MODAL("disable");
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
  },
};
</script>
<style scoped>
.GeneralSales {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}

.ContainerBtnSales {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  margin-top: 70px;
  width: 100%;
  gap: 1rem;
}

.BtnSales {
  width: 30%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 13px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.lineSearch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
  display: flex;
  align-items: center;
}
.searchByMonth {
  width: 100%;
  display: flex;
  align-items: center;
  border-radius: 5px;
  font-size: 11px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.searchFilter {
  width: 120px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.searchFilterSituation {
  width: 200px;
  border-left: none !important;
  height: 30px;
  border-radius: 0px !important;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  position: relative !important;
}

.searchFilterSituation:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.disableInput {
  display: none;
}

.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  font-weight: 600;
}

.custom-select2 {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
  background: none;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  padding: 0 10px;
  border: 1px solid #e3e0e0;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.searchInput {
  display: flex;
  justify-content: center;
}

.searchInputDate {
  width: 40%;
  display: flex;
}

.searchInputAll {
  width: 100px;
  display: flex;
}

.searchAll {
  justify-content: center;
  color: #3a4750;
  font-size: 13px;
  padding: 5px 10px;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}
.pin-container {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.pin-input {
  width: 40px;
  height: 50px;
  text-align: center;
  font-size: 23px;
  font-weight: bold;
  border: 2px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;
}

.pin-input:focus {
  border-color: #42b983;
  box-shadow: 0 0 5px rgba(66, 185, 131, 0.3);
}
.searchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  gap: 10px;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.form-control {
  display: block;
  width: 260px;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  height: 30px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
  width: 100%;
}

.searchBtn {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: black;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 10px;
}

.Arrows {
  border-radius: 5px;
  width: 15px;
  height: 15px;
}

.Arrows:hover {
  background: whitesmoke;
}

.Summary {
  display: flex;
  flex-direction: column;
  width: 25%;
  gap: 10px;
  justify-content: flex-start;
}

.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 65px;
  background: rgb(255, 255, 255);
  border-radius: 7px;
  border: 1px solid #e3e0e0;
  box-shadow: 0px 12px 4px -10px rgba(193, 193, 193, 0.78);
  padding: 10px;
}
.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9px;
  bottom: 24px;
  left: 5px;
  z-index: 2;
  padding: 0 2px;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
  font-weight: 400;
}
.custom-select:disabled {
  color: black;
  background-color: #b2b2b2;
}

.custom-select {
  text-transform: capitalize;
}

.borderInput {
  border-radius: 0 5px 5px 0px;
  height: 30px;
  width: 200px;
  font-size: 12px;
  padding: 0 10px;
}
.BtnRegister {
  width: 200px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 10px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnRegister:focus {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnCounter {
  width: 33.3%;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3ebe2;
  height: 30px;
  gap: 10px;
  border-radius: 3px;
  font-size: 13px;
  margin: 0 1px;
  color: #006458;
  border: 1px solid #7ab5ae;
}
.BtnCounter:hover {
  background: #e3ebe2;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.generalContainer {
  display: flex;
  flex-direction: column;
  padding: 0px;
  width: 100%;
  max-width: 100%;
}

.rowProvisionService {
  height: 100%;
}

.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 40vh;
  max-width: 100%;
  padding: 5px 5px 5px 0;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  gap: 10px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 40px;
  padding: 0 5px;
  gap: 10px;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 5px;
  width: 6%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  background: #006256;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  height: 30px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
}

.btnActions {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #cecece;
  border-radius: 5px;
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}
.borderSale {
  border-left: solid 10px green;
}

.borderBudget {
  border-left: solid 10px rgb(0, 81, 169);
}

.borderBoxFront {
  border-left: solid 10px rgb(64, 59, 116);
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}

.headTable {
  color: whitesmoke;
  background: #3a4750;
  text-align: center;
  height: 30px;
}

.ContentTableBill {
  display: flex;
  flex-direction: column;
  overflow: auto;
  font-size: 13px;
  width: 100%;
  max-width: 100%;
  height: auto;
  margin-top: 10px;
  padding: 0 0 10px 0;
  background: #fbfbfb;
  border: 1px solid rgb(218, 218, 218);
  border-radius: 10px;
}

.noContentTable {
  background: #edebeb;
  padding: 10px;
  height: 100%;
  text-align: center;
  letter-spacing: 0.1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contentStatus {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
}

.contentStatus span {
  cursor: context-menu;
}

.statusPayment {
  background: #eff0f0;
  color: green;
}

.statusPaymentOpen {
  background: #eff0f0;
  color: rgb(132, 132, 132);
}

tr:nth-child(even) {
  background: #f2f3f3;
}

th {
  font-size: 12px;
  font-weight: normal;
}

td {
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.titleModalBill {
  display: flex;
  justify-content: space-between;
  padding: 0px 0px 5px 0px;
  border-bottom: 1px solid #e6e7e8;
}

.textModalBill {
  font-weight: bold;
  width: 95%;
  text-align: center;
}

.closeModalBill {
  cursor: pointer;
}

.closeModalBill:hover {
  color: red;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnModalCancel {
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.contentBtns {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 20px;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.contentMotivo {
  font-size: 13px;
  margin-bottom: 20px;
  padding: 10px;
}

.contentMotivo label {
  position: relative;
  top: 10px;
}

.contentMotivo textarea:focus {
  box-shadow: none;
  border: 1px solid rgb(97, 95, 95);
}

.contentMotivo span {
  position: relative;
  top: 10px;
  color: red;
  cursor: context-menu;
}

.contentMotivo ::placeholder {
  font-size: 12px;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.inputSearch {
  width: 200px;
}
.headerDetails {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #dfdfdf;
  background: #eceded;
  color: #202020;
  font-weight: 600;
  padding: 5px 20px;
  border-radius: 5px 5px 0 0;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 12px;
}

.contentDetails {
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid #dfdfdf;
  border-top: none;
  background: #ffffff;
  color: #202020;
  font-weight: 600;
  padding: 5px 20px;
  border-radius: 0 0 5px 5px;
  letter-spacing: 1px;
  font-size: 12px;
}
.celDetails {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 500;
}

.rowModalDetails {
  display: flex;
  width: 100%;
  padding: 10px 0;
  flex-wrap: wrap;
}

.titleSectionDetails {
  text-align: center;
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 10px;
  width: 100%;
  border-bottom: 1px solid #e6e7e8;
}
.closeModalDetails {
  width: 22px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -2px;
  top: -1px;
  color: red;
  border-radius: 2px;
  cursor: pointer;
  transition: ease-in all 0.2s;
  font-size: 18px;
}

.alertCancel {
  font-size: 10px;
  color: rgb(121, 3, 3);
  text-align: center;
  display: flex;
  margin-bottom: -10px;
  cursor: context-menu;
}

.delBill {
  display: flex;
  justify-content: center;
  align-items: center;
  color: red;
  border: none;
  cursor: pointer;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 30vh;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
  font-weight: bold;
  color: gray;
}

.loadingLazy {
  position: absolute;
  top: 50%;
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

/* spinner */
.loader {
  position: relative;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 30%,
      15% 54%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 69%,
      100% 32%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}

.setBtn {
  display: flex;
  padding: 0 1rem 1rem 0;
  gap: 10px;
  justify-content: flex-end;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 53px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModalSales {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  right: 0;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModalSales:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.btnActions1:hover {
  background: rgb(215, 213, 213);
  color: white;
}

.btnActions1 {
  border-radius: 10px;
}

.contentActions {
  color: #4c4c4c;
  font-weight: 600;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: none !important;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

.typeSale2 {
  color: #48b865;
  font-weight: bold;
}

.typeSale3 {
  color: #006256;
  font-weight: bold;
}

.typeSale4 {
  color: rgb(34, 33, 36);
  font-weight: bold;
}

.typeSale5 {
  color: #f2a83e;
  font-weight: bold;
}

.situationBall {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1px solid rgb(31, 30, 30);
}

.situationContent {
  display: flex;
  align-items: center;
  width: 90px;
  justify-content: flex-start;
  font-weight: bold;
}

.situationContent span {
  margin: 0 0 0 10px;

  font-weight: 600;
}

.situationContainer {
  display: flex;
  width: 100%;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.summaryMonthText {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

.month {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
}

@media screen and (min-width: 758px) and (max-width: 1200px) {
  .GeneralSales {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }

  .searchByMonth {
    width: 40%;
    margin: 10px 0px 0px 10px;
  }

  .form-control {
    width: 140px;
  }

  .ItemSummarySales {
    height: 60px;
    font-size: 11px;
  }

  .SummarySales {
    height: 100px;
    padding-bottom: 10px;
  }

  .BtnSales {
    height: 30px;
    font-size: 11px;
  }

  .searchAll {
    font-size: 11px;
    padding: 5px 9px;
  }

  .searchInputAll {
    width: 18%;
  }

  .searchInputDate {
    width: 45%;
  }

  .btnPeriod {
    width: 60px;
    font-size: 10px;
  }

  .searchFilter {
    width: 100px;
    font-size: 10px;
  }

  .searchContainer {
    height: 70px;
  }

  .setBtn {
    margin: 0 1rem 10px 0;
  }

  .itemBtn {
    width: 18px;
    height: 18px;
  }

  .centerItemBtn {
    width: 18px;
    height: 18px;
  }

  .headTable {
    height: 25px;
  }

  .ContentTable {
    padding: 0px 20px 0 20px;
  }
}

@media screen and (max-width: 700px) {
  .GeneralSales {
    display: flex;
    flex-direction: column;
    margin: auto;
    width: 100%;
    height: 100vh;
    font-size: 10px;
  }

  .ContainerBtnSales {
    margin-top: 55px;
    flex-wrap: wrap;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    margin-left: 0px;
    justify-content: center;
  }

  .searchContainer {
    display: none;
  }

  .BtnSales {
    height: 70px;
  }

  .searchByMonth {
    width: 80%;
    margin: 20px 0px 0px 0px;
  }

  .ItemSummarySales {
    height: 100px;
  }

  .ContentTable {
    height: auto;
    padding: 10px 10px 0 10px;
  }

  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 53px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }
}
</style>
